import clsx from 'clsx'
import type { ReactNode } from 'react'

export type BadgeVariant = 'ja' | 'nein' | 'aktiv' | 'inaktiv' | 'info'

const variants: Record<BadgeVariant, string> = {
  ja: 'bg-fom-50 text-fom-700',
  nein: 'bg-gray-100 text-gray-500',
  aktiv: 'bg-fom-50 text-fom-700',
  inaktiv: 'bg-red-50 text-red-600',
  info: 'bg-blue-50 text-blue-700',
}

interface Props {
  variant: BadgeVariant
  children: ReactNode
  className?: string
}

export default function Badge({ variant, children, className }: Props) {
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded text-[0.66rem] font-semibold uppercase tracking-wide leading-relaxed',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  )
}
